import {
    TABLE_CONTENT_4,
    TABLE_CONTENT_5,
    TABLE_CONTENT_6,
    TABLE_CONTENT_7,
} from '../../../pages/Audioposobie/ui/tableContent';
import { DISK_TRACK_COUNTS } from './constants';

const TABLE_BY_GRADE = {
    '4': TABLE_CONTENT_4,
    '5': TABLE_CONTENT_5,
    '6': TABLE_CONTENT_6,
    '7': TABLE_CONTENT_7,
};

export const getContentTable = (grade, diskNum) => {
    const gradeKey = String(grade);
    const table = TABLE_BY_GRADE[gradeKey];
    return table?.[diskNum] || null;
};

export const hasContentTable = (grade, diskNum) => !!getContentTable(grade, diskNum);

export const getContentTrackNumbers = (grade, diskNum) => {
    const contentTable = getContentTable(grade, diskNum);
    if (!contentTable) return new Set();
    return new Set(contentTable.flatMap((work) => work.tracks.map((t) => t.trackNum)));
};

/** Нужно ли перед треком N проиграть комментарий автора (трек N-1). */
export const shouldPlayCommentaryFirst = (
    grade,
    diskNum,
    trackNum,
    { withCommentary, skipCommentary = false }
) => {
    if (skipCommentary || !withCommentary || trackNum <= 1) return false;
    if (!hasContentTable(grade, diskNum)) return false;
    return !getContentTrackNumbers(grade, diskNum).has(trackNum - 1);
};

export const isCommentaryCheckboxDisabled = (grade, diskNum, trackNum) => {
    if (!hasContentTable(grade, diskNum)) return true;
    return getContentTrackNumbers(grade, diskNum).has(trackNum - 1);
};

export const getAudioSrc = (grade, diskNum, trackNum) =>
    `/audio/${grade}class/disk${diskNum}/Track${trackNum}.MP3`;

export const buildTrackListForDisk = (grade, diskNum) => {
    const gradeKey = String(grade);
    const contentTable = getContentTable(gradeKey, diskNum);
    if (contentTable) {
        return contentTable.flatMap((work) =>
            work.tracks.map((t) => ({
                trackNum: t.trackNum,
                title: work.authorTitle,
            }))
        );
    }
    const trackCount = DISK_TRACK_COUNTS[gradeKey]?.[diskNum];
    if (trackCount) {
        return Array.from({ length: trackCount }, (_, i) => ({
            trackNum: i + 1,
            title: `Трек ${i + 1}`,
        }));
    }
    return [];
};
